import React, { lazy, Suspense } from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import './Home.css';
import Hero from '../components/home/Hero';
import { appStoreUrl } from '../lib/appStore';

// Everything under the fold loads after first paint.
const Story = lazy(() => import('../components/home/Story'));
const Ipad = lazy(() => import('../components/home/Ipad'));
const Lessons = lazy(() => import('../components/home/Lessons'));
const Proof = lazy(() => import('../components/home/Proof'));
const FinalCta = lazy(() => import('../components/home/FinalCta'));

// The Learn custom product page; `ct` names where the tap came from (#19).
export const APP_STORE_URL = appStoreUrl('website_home');

function Home() {
  return (
    <article className="home" itemScope itemType="https://schema.org/WebPage">
      <Helmet>
        <title>Better Parent Everyday — Calm parenting, three minutes a day</title>
        <meta
          name="description"
          content="Duolingo for parents: ask what to do tonight, practice the meltdown before it happens, and learn the skill in ten three-minute lessons. Free on iPhone and iPad."
        />
        <link rel="canonical" href="https://www.betterparenteveryday.com/" />
        <meta property="og:title" content="Better Parent Everyday — Calm parenting, three minutes a day" />
        <meta
          property="og:description"
          content="Ask what to do tonight, practice the hard moment before it happens, and learn the skill in three-minute lessons. Free on iPhone and iPad."
        />
        <meta property="og:url" content="https://www.betterparenteveryday.com/" />
      </Helmet>

      <Hero />

      <Suspense fallback={null}>
        <Story />
        <Ipad />
        <Lessons />
        <Proof />
        <FinalCta />
      </Suspense>
    </article>
  );
}

export default Home;
